module.exports = __webpack_public_path__ + "media/images/top/contact-image-a8a7a419e6cc4c425145fefdde340a94.png";